import PaymentsPage from "components/pages/PaymentsPage";

export default function CaptureQuickTourPayments(props) {
    return <PaymentsPage />
}